export default __webpack_public_path__ + "static/media/mapFrameLandrangerEN.fe5a27fc.jpg";